import React from 'react';
import { CircleDollarSign, Sprout, Factory } from 'lucide-react';

const OperationalSubsidiesSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  operationalSubsidyTypes 
}) => {
  if (!formData.includeOperationalSubsidies) return null;

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Factory className="w-5 h-5 mr-2 text-green-500" />
        Субсидии на операционные расходы
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма запрашиваемой субсидии */}
        <div>
          <label htmlFor="operationalSubsidiesAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Запрашиваемая сумма субсидии
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <CircleDollarSign className="h-4 w-4 text-gray-500 dark:text-gray-400" />
            </div>
            <input
              type="text"
              id="operationalSubsidiesAmount"
              name="operationalSubsidiesAmount"
              value={formData.operationalSubsidiesAmount}
              onChange={handleInputChange}
              className={`form-input w-full pl-9 ${errors.operationalSubsidiesAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
          </div>
          {errors.operationalSubsidiesAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.operationalSubsidiesAmount}
            </p>
          )}
        </div>

        {/* Тип операционных расходов */}
        <div>
          <label htmlFor="operationalSubsidiesType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип операционных расходов
          </label>
          <select
            id="operationalSubsidiesType"
            name="operationalSubsidiesType"
            value={formData.operationalSubsidiesType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.operationalSubsidiesType ? 'input-error' : ''}`}
          >
            {operationalSubsidyTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name} ({type.fundingPercent}%)
              </option>
            ))}
          </select>
          {errors.operationalSubsidiesType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.operationalSubsidiesType}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <Sprout className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Информация об операционных субсидиях
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Субсидии предоставляются для компенсации затрат на семена, удобрения, средства защиты растений, 
              ГСМ и другие операционные расходы. Субсидирование может покрывать от 25% до 60% 
              от фактических затрат в зависимости от типа расходов.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalSubsidiesSection;